import { urlDecorator } from './ajax/technicalParamsUrlDecorator';

const prepareModalTemplate = ({
    modalSize,
    modalTarget,
    modalScrollable,
    backdrop,
    focus,
    keyboard,
}) => {
    const modalTemplate = document.querySelector('template#modal-template');

    const template = modalTemplate.content.cloneNode(true);

    const modal = template.querySelector('.modal');
    modal.id = modalTarget.replace('#', '');
    const modalDialog = template.querySelector('.modal-dialog');
    const modalContent = template.querySelector('.modal-content');

    // lg is default modal size
    modalDialog.classList.add(modalSize || 'modal-lg');
    if (modalScrollable) {
        modalDialog.classList.add('modal-dialog-scrollable');
        modalContent?.classList.add('h-100');
    }

    document.body.append(template);

    const modalInstance = new window.bootstrap.Modal(modal, {
        backdrop,
        focus,
        keyboard,
    });

    modal.addEventListener('hidden.bs.modal', () => {
        modal.remove();
    });

    return { modalElement: modal, modalInstance };
};

export const openRemoteModal = async (url, config = {}) => {
    const DEFAULT_MODAL_CONFIG = {
        modalTarget: '#modal-container',
        modalSize: 'modal-lg',
        modalScrollable: false,
        backdrop: true,
        keyboard: true,
        focus: true,
    };

    const cfg = Object.keys(DEFAULT_MODAL_CONFIG).reduce(
        (acc, key) => ({
            ...acc,
            [key]: config[key] || DEFAULT_MODAL_CONFIG[key],
        }),
        {}
    );

    const { modalElement, modalInstance } = prepareModalTemplate(cfg);
    const modalContentElement = modalElement.querySelector('.modal-content');

    window.dispatchEvent(
        new CustomEvent('remoteModal.loading', { detail: { modal: modalElement } })
    );

    try {
        const response = await fetch(urlDecorator(url));

        const html = await response.text();

        modalContentElement.innerHTML += html;

        modalInstance.show();

        window.dispatchEvent(
            new CustomEvent('RemoteContentLoaded', {
                container: modalContentElement,
            })
        );

        window.dispatchEvent(
            new CustomEvent('remoteModal.loaded', {
                detail: {
                    modal: modalElement,
                },
            })
        );

        window.dispatchEvent(
            new CustomEvent(`remoteModal.${cfg.modalTarget}.loaded`, {
                detail: {
                    modal: modalElement,
                },
            })
        );
    } catch (err) {
        // console.error(err);
        const error = new Error('Error while loading remote modal');
        console.error(error);
    }
};

export const remoteModalListener = (toggler) => {
    const url = toggler.dataset.bsRemote;
    const config = {
        modalTarget: toggler.dataset.bsTarget,
        modalSize: toggler.dataset.bsSize,
        modalScrollable: toggler.dataset.bsScrollable,
        backdrop: toggler.dataset.bsBackdrop,
        keyboard: toggler.dataset.bsKeyboard,
        focus: toggler.dataset.bsFocus,
    };

    openRemoteModal(url, config);
};
